import React, { Component, useRef } from 'react';
import { Request } from 'components/Request';
import TierRestriction from '../../models/TierRestriction';
import PlainLeague from 'react/PlainLeague';
import { JqueryClassFaker } from '../../components/JqueryClassFaker';

import PropTypes from 'prop-types';
import { GameRoom } from '../../models/GameRoom';
import InputSwitch from '../elements/InputSwitch';
import ActiveSelectableButton from '../elements/ActiveSelectableButton';
import KeepOnScreenPositioner from '../elements/KeepOnScreenPositioner';
import OutsideAlerter from '../elements/OutsideAlerter';
import PickSearchesComponent from './PickSearchesComponent';
import useWavesEffect from "../hooks/useWavesEffect";
import RankedRestrictionTierDisplay from "./RankedRestrictionTierDisplay";
import RadioButton from "../elements/RadioButton";
import RadioButtonHolder from "../elements/RadioButtonHolder";
import TierDivisionsInteractiveComponent from "./TierDivisionsInteractiveComponent";

export default class RankedRestrictionsComponent extends Component {
	static defaultProps = {
		changingTierRestrictions: false,
	};
	static propTypes = {
		ladder: PropTypes.instanceOf(GameRoom)
	};

	constructor(props) {
		super(props);

		this.state = {
			pendingTierRestriction: {},
		};
		this.restrictionClick = this.restrictionClick.bind(this);
		this.cancelSelectRestrictions = this.cancelSelectRestrictions.bind(this);
		this.updateDirectionToggle = this.updateDirectionToggle.bind(this);
		this.setToNoRestrictions = () => {
			this.restrictionClick(null, null);
		};

		this.nullRestrictionClick = () => {
			props.setCurrentEditMatchmakingPage(PickSearchesComponent.fullPages.EDIT_RANK_RESTRICTIONS);
		};

		this.onDivisionClick = this.onDivisionClick.bind(this);
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	updateDirectionToggle(setTo) {
		const { ladder } = this.props;
		const tierRestriction = myUser.tier_restrictions[ladder.id] || {};
		if(tierRestriction.direction > -1) {
			console.error('Direction toggle clicked while a direction restriction is already set');
			return;
		}
		this.restrictionClick(null, setTo);
	}

	cancelSelectRestrictions() {
		const { setCurrentEditMatchmakingPage } = this.props;
		setCurrentEditMatchmakingPage(PickSearchesComponent.fullPages.INDEX);
	}

	onDivisionClick(divisionNumber) {
		const { ladder } = this.props;
		const newTierRestriction = TierRestriction.create({ ...myUser.tier_restrictions[ladder.id] });


		console.log('before division', newTierRestriction.division, divisionNumber);
		newTierRestriction.division = newTierRestriction.division === divisionNumber ? 0 : divisionNumber;
		myUser.update({
			tier_restrictions: newTierRestriction
		});
		this.setState({ pendingTierRestriction: newTierRestriction });
		Request.apiv1('matchmaking/update_rank_preference', { ladder_id: ladder.id, division: divisionNumber })
			.catch((response) => {
				Request.generalJsonError(response);
			});
	}

	restrictionClick(tierId, direction, e) {
		const { ladder, changingTierRestrictions } = this.props;
		if(!changingTierRestrictions && tierId) {
			this.cancelSelectRestrictions();
			return;
		}
		const newTierRestriction = TierRestriction.create({
			ladder_id: ladder.id,
			tier_id: tierId,
			direction: direction
		});

		const previousTierRestriction = TierRestriction.create({ ...myUser.tier_restrictions[ladder.id] });

		let toggleCurrentView = true;
		if(!newTierRestriction.tier_id) { // This case happens if we're just updating the direction from -1 to -2 and vice versa (Allowing unranked)
			newTierRestriction.tier_id = previousTierRestriction.tier_id;
			toggleCurrentView = false;
		}
		if(previousTierRestriction.direction === newTierRestriction.direction && previousTierRestriction.tier_id === tierId || direction === null) {
			newTierRestriction.direction = 0;
			toggleCurrentView = true;
		}
		this.setState({ pendingTierRestriction: newTierRestriction });
		myUser.update({
			tier_restrictions: newTierRestriction
		});
		if(toggleCurrentView) {
			this.cancelSelectRestrictions();
		}
		Request.apiv1('matchmaking/update_rank_preference', newTierRestriction.serialize())
			.catch((response) => {
				Request.generalJsonError(response);
			});
	}

	render() {
		const { ladder, changingTierRestrictions } = this.props;
		const { pendingTierRestriction } = this.state;
		if(!ladder) {
			console.error('ladder was not provided');
			return null;
		}
		const tierRestriction = myUser.tier_restrictions[ladder.id] || {};
		const season = ladder.getActiveSeason();
		if(!season) {
			console.error('no active season for this ladder');
			return null;
		}
		if(!season.tiers) {
			console.error('Season has no tiers');
			return null;
		}
		const sendProps = {
			selectedTierRestriction: tierRestriction,
			pendingTierRestriction,
			tiers: season.tiers,
			restrictionClick: this.restrictionClick,
		};
		const unrankedTier = season.getUnrankedTier();

		let currentDisplayedTier = null;
		let activeRestriction = null;
		if(_.isEmpty(tierRestriction) || tierRestriction.direction === 0) {
			if(_.isEmpty(pendingTierRestriction) || pendingTierRestriction.direction === 0) {
				activeRestriction = {
					direction: 0
				};
			}
			else {
				activeRestriction = pendingTierRestriction;
			}
		}
		else {
			activeRestriction = tierRestriction;
		}
		if(!activeRestriction || activeRestriction.direction === 0) {
			currentDisplayedTier = unrankedTier;
		}
		else {
			currentDisplayedTier = season.tiers.find((tier) => {
				return tier.id === activeRestriction.tier_id;
			});
		}

		const unrankedIsSelected = currentDisplayedTier === unrankedTier;

		if(changingTierRestrictions) {
			return (
				<div
					className={`selecting_rank_restrictions panel-body active`}>
					<ActiveSelectableButton
						block
						onClick={this.cancelSelectRestrictions}
					>
						Keep Search Restrictions The Same
					</ActiveSelectableButton>
					<h5 className='page-sub-heading'>
						Friendlies use highest achieved rank, ranked matches use the players's current rank
					</h5>
					<RankedRestrictionDirection
						currentDirection={1}
						{...sendProps}>
								<span className='accept_description'>
									<i className='fa fa-arrow-up' />
								</span>
					</RankedRestrictionDirection>
					<RankedRestrictionDirection
						currentDirection={-1}
						{...sendProps}>
							<span className='accept_description'>
								<i className='fa fa-arrow-down' />
							</span>
					</RankedRestrictionDirection>
					<ActiveSelectableButton
						block
						large
						disabled={activeRestriction.direction === 0}
						onClick={this.setToNoRestrictions}
					>
						No Restrictions
					</ActiveSelectableButton>
				</div>
			);
		}

		return (
			<div className=''>
				<div className='ranked_restrictions_holder'>
					<div
						onClick={this.nullRestrictionClick}
						className='add_restriction'>
						<div>
							<span
								className='hint'>
								{unrankedIsSelected ? 'Edit Rank Restriction' : 'Accepting'}
							</span>
							<RankedRestrictionTierDisplay
								ladder={ladder}
								tier={currentDisplayedTier}
								restriction={activeRestriction}
							/>
						</div>
					</div>
					{!unrankedIsSelected &&
					<div className='form-group'>
						<TierDivisionsInteractiveComponent
							selectedDivision={tierRestriction.division}
							onDivisionClick={this.onDivisionClick}
						/>
					</div>
					}
					{tierRestriction.direction <= -1 &&
					<RadioButtonHolder>
						<RadioButton
							onClick={this.updateDirectionToggle.bind(null, -1)}
							glow={tierRestriction.direction === -1}
						>
							Do Not Include Unranked
						</RadioButton>
						<RadioButton
							onClick={this.updateDirectionToggle.bind(null, -2)}
							glow={tierRestriction.direction === -2}
						>
							<PlainLeague
								league={unrankedTier}
							/>
							<div>
								Include Unranked
							</div>
						</RadioButton>
					</RadioButtonHolder>
					}
				</div>
			</div>
		);
	}
}

class RankedRestrictionDirection extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { tiers } = this.props;
		return (
			<div className='ladder_settings'>
				<div className='description_group'>
					{this.props.children}
					<div className='acceptable_tiers'>
						{tiers.filter(tier => !tier.is_unranked).map((tier) => {
							return (
								<RankedRestrictionTier
									key={tier.id}
									tier={tier}
									{...this.props}
								/>
							);
						})}
					</div>
					{this.props.children}
				</div>
			</div>
		);
	}
}

function RankedRestrictionTier(props) {

	const { restrictionClick, tier, currentDirection } = props;

	const { selectedTierRestriction, pendingTierRestriction } = props;
	const restrictionClickBound = restrictionClick.bind(null, tier.id, currentDirection);
	const isSelected = isSameAsTierSetting(selectedTierRestriction, tier);
	const isPending = isSameAsTierSetting(pendingTierRestriction, tier);
	const ref = useRef(null);
	useWavesEffect(ref);

	function isSameAsTierSetting(tierSetting, tier) {
		const { currentDirection } = props;
		return (tier.id === tierSetting.name_id || tier.id === tierSetting.tier_id)
			&& ((tierSetting.direction <= -1 && currentDirection <= -1)
				|| (tierSetting.direction >= 1 && currentDirection >= 1));
	}

	const classes = new JqueryClassFaker();
	if(isSelected) {
		classes.add('selected');
	}
	if(isSelected) {
		classes.add('displayed_alone');
	}
	if(isPending) {
		classes.add('pending');
	}
	return (
		<div
			ref={ref}
			onClick={restrictionClickBound}
		>
			<div
				className={`tier_select ${classes.toString()}`}>
				<PlainLeague
					league={tier}
				/>
			</div>
		</div>
	);
}
